import script from "./procurement-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./procurement-dashboard.vue?vue&type=script&setup=true&lang=js"

import "./procurement-dashboard.vue?vue&type=style&index=0&id=a904eec8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a904eec8"]])

export default __exports__